import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import withStyles from '@material-ui/core/styles/withStyles'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import OutlinedInput from '@material-ui/core/OutlinedInput'

const styles = theme => ({
	main: {
		width: 'auto',
		display: 'block',
		position: 'absolute',
		right: 0,
		marginTop: theme.spacing(0.5),
		marginLeft: theme.spacing(3),
		marginRight: theme.spacing(2),
		[theme.breakpoints.down(480)]: {
			marginRight: theme.spacing(0.5),
		},
	},
	formControl: {
		margin: theme.spacing(0),
		minWidth: 100,
		[theme.breakpoints.down(360)]: {
			minWidth: 98,
			width: 100,
		},
	},
	resize: {
		fontSize: 50
	},
})

const LanguageSelector = (props) => {
	const { classes } = props
	const { i18n } = useTranslation()
	const [state, setState] = useState({
		lang: localStorage.getItem('language'),
		name: 'en',
	})

	const currentLanguage = localStorage.getItem('language')

	useEffect(() => {
		setState({
			lang: localStorage.getItem('language'),
			name: localStorage.getItem('language')
		})
		i18n.changeLanguage(localStorage.getItem('language'))
	}, [currentLanguage, i18n])

	const handleChange = name => event => {
		setState({
			...state,
			[name]: event.target.value,
		})
		i18n.changeLanguage(event.target.value)
	}

	return (
		<main className={classes.main}>
			<FormControl variant="outlined" className={classes.formControl}>
				<InputLabel htmlFor="language"></InputLabel>
				<Select
					native
					value={state.lang}
					onChange={handleChange('lang')}
					input={
						<OutlinedInput margin='dense' />
					}
					inputProps={{
						name: 'age',
						id: 'language',
					}}
				>
					<option value="en">English</option>
					<option value="de">Deutsch</option>
					<option value="it">Italiano</option>
				</Select>
			</FormControl>
		</main>
	)
}

export default withStyles(styles)(LanguageSelector)